import { styled } from '@mui/material';

import Layout, { layoutClasses, Props as LayoutProps } from '../Layout';

export const Root = styled((props: DistributiveOmit<LayoutProps, 'title'>) => <Layout {...props} title="" />)(
  ({ theme }) => ({
    [`& .${layoutClasses.contentHeader}`]: {
      display: 'none',
    },
    [`& .${layoutClasses.content}`]: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(5),
      textAlign: 'center',
    },
  })
);
